// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-property-value-disallowed-list -- DS Component */
:root {
    /* Background colors */
    --ds-indicator-bg-highlight: var(--ds-color-indigo-3);
    --ds-indicator-bg-neutral: var(--ds-color-white);
    --ds-indicator-bg-danger: var(--ds-color-negative);
    --ds-indicator-bg-alert: var(--ds-color-alert);
    --ds-indicator-bg-positive: var(--ds-color-positive);
    --ds-indicator-bg-informative: var(--ds-color-informative);
    /* Content colors (text & icon) */
    --ds-indicator-color-light: var(--ds-color-white);
    --ds-indicator-color-dark: var(--ds-color-charcoal);
    --ds-indicator-color-brand: var(--ds-color-indigo-3);
    /* Border — always applied; */
    --ds-indicator-border-color: var(--ds-color-white);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
